import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/main/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { scrubBreadcrumb, scrubEvent } from './app/main/providers/sentry/sentry-scrub';
import { SENTRY_RELEASE } from './app/main/providers/sentry/sentry-release';
import { init as initPlausible } from '@plausible-analytics/tracker';

// Configure moment.js early to suppress deprecation warnings
import moment from 'moment';
import 'moment-timezone';
(moment as any).suppressDeprecationWarnings = true;

if (environment.production) {
  enableProdMode();
}

if (environment.plausibleDomain) {
  initPlausible({
    domain: environment.plausibleDomain,
    endpoint: 'https://plausible.zitemedia.com/api/event',
  });
}

if (environment.useSentry) {
  Sentry.init({
    dsn: environment.sentryDSN,
    environment: environment.sentryEnvName,
    release: SENTRY_RELEASE,
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
    ],

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [environment.apiUrl + 'temp_fix'], // todo set backend headers

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Browser extensions, not our code (Sentry JETFUELTENDERS-1RQ: a Safari extension's "Message did
    // timeout", frames at webkit-masked-url://hidden/). Their scripts run in our page and their
    // errors reach the global handlers; never report them.
    denyUrls: [/^webkit-masked-url:/, /^(chrome|moz|safari|safari-web)-extension:\/\//],
    ignoreErrors: [/^Message did timeout$/],

    // Reset / verify / invitation / OTP tokens and OAuth code/state live in URLs:
    // strip them from every event, transaction and breadcrumb (FE-4).
    beforeSend: (event) => scrubEvent(event),
    beforeSendTransaction: (event) => scrubEvent(event),
    beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
  });
  enableProdMode();

}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(moduleRef => {
    // Enable Hot Module Replacement in development
    if ((module as any).hot) {
      (module as any).hot.accept();
      (module as any).hot.dispose(() => {
        moduleRef.destroy();
      });
    }
  })
  .catch(err => console.error(err));
